module.exports = __webpack_public_path__ + "img/icon-3.d3d14a26.png";